'use client';

import type { FC } from 'react';
import { cn } from '../../utils/cn';
import { Text } from './Text';

interface EmptyStateProps {
  message?: string;
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  /** Way out of the dead end: one button, same slot as «Повторить» in ErrorMessage. */
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: FC<EmptyStateProps> = ({ message, title, description, icon, action, className }) => {
  return (
    <div className={cn('text-center px-5 py-10 text-subtle', className)}>
      {icon && <div className="mb-3 flex justify-center">{icon}</div>}
      {title && (
        <Text color="primary">
          {title}
        </Text>
      )}
      {description && (
        <Text color="secondary">
          {description}
        </Text>
      )}
      {message && <Text color="secondary">{message}</Text>}
      {action && <div className="mt-5 flex justify-center">{action}</div>}
    </div>
  );
};
